import { render, staticRenderFns } from "./CampaignMedia.vue?vue&type=template&id=21a02fef&scoped=true&"
import script from "./CampaignMedia.vue?vue&type=script&lang=ts&"
export * from "./CampaignMedia.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignMedia.vue?vue&type=style&index=0&id=21a02fef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a02fef",
  null
  
)

export default component.exports